<template>
    <div>
        <rkm-form-checkbox-group v-model="model.fatoresRisco">
            <rkm-row>
                <rkm-col
                    v-for="fatorRisco in fatoresRisco"
                    v-bind:key="fatorRisco.id"
                    cols="6"
                >
                    <rkm-form-checkbox
                        :value="fatorRisco.id"
                        inline
                    >
                        {{ fatorRisco.nome }}
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form-checkbox-group>

        <rkm-row v-if="model.fatoresRisco.includes(enums.fatorRisco.OUTRO)">
            <rkm-col>
                <rkm-form-input
                    v-model="model.fatorRiscoOutro"
                    :validations="validations.outro"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

import fatorRisco from '@/enums/cadastro/cidadao/fatorRisco'
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        enums: {
            fatorRisco,
            sexo,
        },
    }),
    computed: {
        validations() {

            return {
                outro: { max: 100 }
            }
        },
        fatoresRisco(){

            if(this.model.sexoId == this.enums.sexo.FEMININO
                && this.model.idade >= 9 && this.model.idade <= 60){
                    return this.form.fatoresRiscoGestante
            }

            return this.form.fatoresRisco
        }
    },
    watch: {
        'model.fatoresRisco': function (fatoresRisco) {

            if (!fatoresRisco.includes(this.enums.fatorRisco.OUTRO)) {

                this.model.fatorRiscoOutro = ''
            }
        }
    }
}
</script>